(function () {
    'use strict';


    angular
        .module('app')
        .controller('uploadController', uploadController);

    uploadController.$inject = ['$location', '$mdDialog', 'FileUploader', '$injector', '$scope', '$timeout', 'uploadFactory', 'loginService'];

    function uploadController($location, $mdDialog, FileUploader, $injector, $scope, $timeout, uploadFactory, loginService) {
        /* jshint validthis:true */
        var vm = this;

        var uploader = vm.uploader = new FileUploader({
            url: '/Synergis.WebAPI/api/CheckIn/Upload'
        });




        $scope.title = 'uploadController';
        $scope.mdDialog = $mdDialog;
        // queues to manage retry, failure, and success
        var retryQueue = new Collection();        // create a collection queue to retry in case the token needs to be refreshed
        var failedCollection = new Collection();  // create a collection of failed items, used for email notification when OK is clicked.
        var duplicateCollection = new Collection();  // Keeps track of duplicate files added to queue.

        loginService.getLongTermKey().then(function (token) {
            uploader.headers = { Authorization: 'Bearer ' + token };
        })
        var statusBarColor = 'orange';
        $scope.uploadDocumentsLabel = loginService.resourceStrings["UPLOAD_DOCUMENTS"]; // "Upload Documents"

        var nameLabel = loginService.resourceStrings["FILENAME"]; // "Filename"
        var sizeLabel = loginService.resourceStrings["SIZE"]; // "Size"
        var progressLabel = loginService.resourceStrings["PROGRESS"]; // "Progress"
        var statusLabel = loginService.resourceStrings["STATUS"]; // "Status"
        var actionsLabel = loginService.resourceStrings["ACTIONS"]; // "Actions"

        $scope.successLabel = loginService.resourceStrings["SUCCESS"]; // "Success"
        $scope.cancelledLabel = loginService.resourceStrings["CANCELLED"]; // "Cancelled"
        $scope.errorLabel = loginService.resourceStrings["ERROR"]; // "Error"
        $scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        $scope.browseLabel = loginService.resourceStrings["BROWSE"]; // "Browse"
        $scope.uploadAllLabel = loginService.resourceStrings["UPLOAD_ALL"]; // "Upload all"
        $scope.cancelAllLabel = loginService.resourceStrings["CANCEL_ALL"]; // "Cancel all"
        $scope.clearAllLabel = loginService.resourceStrings["CLEAR_ALL"]; // "Clear all"

        $scope.okLabel = loginService.resourceStrings["OK"]; // "OK"

        var gridData = [];

        $scope.gridOptions = {
            enableSelectionBatchEvent: false,
            multiSelect: false,
            modifierKeysToMultiSelect: false,
            enableFullRowSelection: false,
            enableRowHeaderSelection: false,
            useExternalSorting: false,
            enableColumnMenus: false,
            enableColumnResizing: true,
            rowHeight: 20,
            //            rowTemplate: rowTemplate(),
            columnDefs: [
                        { name: nameLabel, field: 'name', width: '60%', minWidth: '100', height: '12', cellTemplate: '<div>{{ grid.appScope.getFilename(grid,row) }}</div>' },
                        { name: sizeLabel, field: 'size', width: '10%', minWidth: '50', cellTemplate: '<div>{{ grid.appScope.getSize(grid,row)/1024/1024|number:2 }} MB</div>' },
                        { name: progressLabel, field: 'progress', width: '10%', minWidth: '50', cellTemplate: '<div><b>{{grid.appScope.getProgress(grid,row)}}%</b></div>' },
                        { name: statusLabel, field: 'status', width: '10%', minWidth: '50', cellTemplate: '<span ng-show="grid.appScope.getItem(grid,row).isSuccess"><i class="glyphicon glyphicon-ok"></i>{{grid.appScope.successLabel}}</span><span ng-show="grid.appScope.getItem(grid,row).isCancel"><i class="glyphicon glyphicon-ban-circle"></i>{{grid.appScope.cancelledLabel}}</span><span ng-show="grid.appScope.getItem(grid,row).isError"><i class="glyphicon glyphicon-remove"></i>{{grid.appScope.errorLabel}}</span>' },
                        { name: actionsLabel, field: 'action', width: '10%', minWidth: '50', cellTemplate: '<button type="button" class="button secondary-button-action button-xxs" ng-click="grid.appScope.getItem(grid,row).upload()" ng-disabled="grid.appScope.getItem(grid,row).isReady || grid.appScope.getItem(grid,row).isUploading || grid.appScope.getItem(grid,row).isSuccess"><span class="glyphicon glyphicon-upload"></span></button>&nbsp;<button type="button" class="button secondary-button-cancel button-xxs" ng-click="grid.appScope.getItem(grid,row).cancel()" ng-disabled="!grid.appScope.getItem(grid,row).isUploading"><span class="glyphicon glyphicon-ban-circle"></span></button>&nbsp;<button type="button" class="button secondary-button-clear button-xxs" ng-click="grid.appScope.removeItem(grid,row)"><span class="glyphicon glyphicon-remove"></span></button>' }],
            data: gridData
        };

        ///////////////////////////////////////////////////////////////////////
        // Grid helper functions
        ///////////////////////////////////////////////////////////////////////
        $scope.removeItem = function (grid, myRow) {
            var item = $scope.getItem(grid, myRow);
            $scope.gridOptions.data.splice($scope.getRowIndex(grid, myRow), 1);
            item.remove();
        }

        $scope.removeAll = function () {
            $scope.gridOptions.data.splice(0, $scope.gridOptions.data.length);
            gridData.splice(0, $scope.gridOptions.data.length);
            uploader.clearQueue();
        }

        // File properties
        $scope.getFilename = function (grid, myRow) {
            var item = $scope.getItem(grid, myRow);
            if (item != null) return item.file.name;
            return null;
        }

        $scope.getSize = function (grid, myRow) {
            var item = $scope.getItem(grid, myRow);
            if (item != null) return item.file.size;
            return 0;
        }

        $scope.getProgress = function (grid, myRow) {
            var item = $scope.getItem(grid, myRow);
            if (item != null) return item.progress;
            return 0;
        }

        $scope.getItem = function (grid, myRow) {
            var index = $scope.getRowIndex(grid, myRow);
            return grid.appScope.vm.uploader.queue[index];
        }

        $scope.getRowIndex = function (grid, myRow) {
            var myRowFound = false;
            var rowIndex = 0;
            grid.renderContainers.body.visibleRowCache.forEach(function (row, index) {
                if (!myRowFound) {
                    if (row === myRow) {
                        myRowFound = true;
                        rowIndex = index;
                    }
                }
            });
            return rowIndex;
        };


        ///////////////////////////////////////////////////////////////////////
        // Functions for this service
        ///////////////////////////////////////////////////////////////////////
        vm.updateRecord = function () {
            gridData[0].name = 'test';
        }

        // Email Notification
        $scope.okButtonClicked = function () {
            console.info('Sending notification email');

            if (uploadFactory.getLength() > 0) {
                uploadFactory.sendEmailNotification().then(function (response) {
                    // do something
                    console.info('sendEmailNotification', response);
                });
            }

            // Call the parent - $mddialog's onOK()
            $scope.onOK();
        }

        ///////////////////////////////////////////////////////////////////////
        // Upload control overrides
        ///////////////////////////////////////////////////////////////////////
        /*
                // Upload FILTERS
                uploader.filters.push({
                    name: 'customFilter',
                    fn: function (item , options) {
                        return this.queue.length < 10;
                    }
                });
        */
        // Upload CALLBACKS
        uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
            //console.info('onWhenAddingFileFailed', item, filter, options);
        };
        uploader.onAfterAddingFile = function (fileItem) {
            console.info('onAfterAddingFile', fileItem);
            // Add newly added item to grid
            var item = {
                "name": fileItem.file.name,
                "size": fileItem.file.size,
                "progress": fileItem.progress,
                "status": "",
                "action": ""
            };
            gridData.push(item);


            // Ready queue
            var readyQueue = this.getNotUploadedItems();
            var ii = readyQueue.length;
            var count = 0;
            while (ii-- > 0) {
                console.info('onAfterAddingFile fileName=' + fileItem.file.name);
                if (readyQueue[ii].file.name == fileItem.file.name &&
                    ++count > 1) {
                    // Ensure that the filename is added to the duplicate warning message only once.
                    if (duplicateCollection.exists(fileItem.file.name) == false) {
                        if ($scope.duplicateFilenameMessage == null) {
                            $scope.duplicateFilenameMessage = loginService.resourceStrings["UPLOAD_DUPLICATE_FILE_MESSAGE"];
                        }
                        else {
                            $scope.duplicateFilenameMessage += ',';
                        }
                        $scope.duplicateFilenameMessage += fileItem.file.name;
                        duplicateCollection.add(fileItem.file.name, fileItem);
                    }
                    this.removeFromQueue(fileItem);
                }
            }
        };
        uploader.onAfterAddingAll = function (addedFileItems) {
            //console.info('onAfterAddingAll', addedFileItems);
        };
        uploader.onBeforeUploadItem = function (item) {
            console.info('onBeforeUploadItem', item);
        };
        uploader.onProgressItem = function (fileItem, progress) {
            //console.info('onProgressItem', fileItem, progress);
        };
        uploader.onProgressAll = function (progress) {
            //console.info('onProgressAll', progress);
        };
        uploader.onSuccessItem = function (fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
            statusBarColor = 'green';
            if (uploadFactory.existsInCollection(response) == false) {
                uploadFactory.addToCollection(response, "true", '');
            }
            // remove from the failed, if it is there.
            //uploadFactory.removeFromCollection(fileItem.file.name);
            if (retryQueue.exists(fileItem.file.name) == true) {
                retryQueue.remove(fileItem.file.name);
            }
            if (failedCollection.exists(fileItem.file.name) == true) {
                failedCollection.remove(fileItem.file.name);
                //uploadFactory.removeFromCollection(fileItem.file.name);
            }
        };

        uploader.onErrorItem = function (fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);

            if (failedCollection.exists(fileItem.file.name) == false) {
                failedCollection.add(fileItem.file.name, fileItem); // Add to failed collection, can be removed if successful.
                uploadFactory.addToCollection(fileItem.file.name, "false", response.Message);
            }
            //unauthorized
            if (status == '401') {
                //add the file item to the queue
                //if (retryQueue.exists(fileItem.file.name) == false)
                {
                    retryQueue.add(fileItem.file.name, fileItem);
                    console.info('onErrorItem : refreshing token...', fileItem, response, status, headers);
                    loginService.refreshToken().then(function () {
                        angular.forEach(retryQueue.getArray(), function (fileItem) {
                            if (fileItem != null) {
                                console.info('retryQueue : retrying : ' + fileItem.file.name);
                                fileItem.headers.Authorization = 'Bearer ' + loginService.access_token;
                                fileItem.upload();
                            }
                        });
                        retryQueue.removeAll();
                    });
                }
            }
        };
        uploader.onCancelItem = function (fileItem, response, status, headers) {
            //console.info('onCancelItem', fileItem, response, status, headers);
        };
        uploader.onCompleteItem = function (fileItem, response, status, headers) {
            //console.info('onCompleteItem', fileItem, response, status, headers);
        };
        uploader.onCompleteAll = function () {
            console.info('onCompleteAll');
            $scope.duplicateFilenameMessage = null;
        };

        ///////////////////////////////////////////////////////////////////////
        // Collection "class"
        ///////////////////////////////////////////////////////////////////////
        function Collection() {
            var collection = {};
            var order = [];
            var valueArray = [];

            this.add = function (property, value) {
                if (!this.exists(property)) {
                    collection[property] = value;
                    order.push(property);
                    valueArray.push(value);
                }
            }
            this.length = function () {
                return order.length;
            }
            this.remove = function (property) {
                collection[property] = null;
                var ii = order.length;
                while (ii-- > 0) {
                    console.info('remove = function : order[ii]=' + order[ii] + ' property=' + property);
                    if (order[ii] == property) {
                        order[ii] = null;
                        break;
                    }
                }
                var ii = valueArray.length;
                while (ii-- > 0) {
                    console.info('remove = function : valueArray[ii]=' + valueArray[ii] + ' property=' + property);
                    if (valueArray[ii] == property) {
                        valueArray[ii] = null;
                        break;
                    }
                }
            }
            this.removeAll = function (property) {
                collection[property] = null;
                order.splice(0, order.length);
                valueArray.splice(0, valueArray.length);
            }
            this.toString = function () {
                var output = [];
                for (var ii = 0; ii < order.length; ++ii) {
                    if (order[ii] != null) {
                        output.push(collection[order[ii]]);
                    }
                }
                return output;
            }
            this.getArray = function () {
                return valueArray;
            }
            this.getKeys = function () {
                var keys = [];
                for (var ii = 0; ii < order.length; ++ii) {
                    if (order[ii] != null) {
                        keys.push(order[ii]);
                    }
                }
                return keys;
            }
            this.update = function (property, value) {
                if (value != null) {
                    collection[property] = value;
                }
                var ii = order.length;
                while (ii-- > 0) {
                    if (order[ii] == property) {
                        order[ii] = null;
                        order.push(property);
                        break;
                    }
                }
            }
            this.exists = function (property) {
                return collection[property] != null;
            }
        }
    }
})();
